import { useEffect, useMemo, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

import { AspirationsToday } from '@/types.gql';

import { OpuSearchActions } from './components/OpuSearchActions/index.tsx';
import { OpuSearchForm } from './components/OpuSearchForm/index.tsx';
import { OpuSearchGrid } from './components/OpuSearchGrid/index.tsx';
import { OpuSearchSelector } from './components/OpuSearchSelector/index.tsx';
import OpuSearchContext from './hooks/useOpuContext';

import './OpuSearch.css';

type OpuSearchProps = {
  className?: string;
  children: React.ReactNode;
};

const OpuSearch = ({ className, children }: OpuSearchProps) => {
  const [params, setParams] = useSearchParams();

  const opuSiteId = params.get('site');

  const [selectedAspiration, setSelectedAspiration] =
    useState<AspirationsToday>();
  const [qcDataSubmitted, setQcDataSubmitted] = useState(false);

  useEffect(() => {
    if (opuSiteId !== '087071b7-cdb2-e911-818b-005056975fe0') {
      setParams((prev) => {
        const currentLocation = prev.get('location');
        if (!currentLocation) {
          return prev;
        }
        const newParams = new URLSearchParams(prev);
        newParams.delete('location');
        return newParams;
      });
    }
  }, [opuSiteId, setParams]);

  const value = useMemo(
    () => ({
      selectedAspiration: selectedAspiration,
      setSelectedAspiration: setSelectedAspiration,
      qcDataSubmitted,
      setQcDataSubmitted,
    }),
    [selectedAspiration, qcDataSubmitted],
  );

  return (
    <div className={`common-page opu-search ${className}`.trim()}>
      <OpuSearchContext.Provider value={value}>
        {children}
      </OpuSearchContext.Provider>
    </div>
  );
};

const Root = OpuSearch;
const Selector = OpuSearchSelector;
const Form = OpuSearchForm;
const Grid = OpuSearchGrid;
const Actions = OpuSearchActions;

export {
  Actions,
  Form,
  Grid,
  OpuSearch,
  OpuSearchForm,
  OpuSearchGrid,
  OpuSearchSelector,
  Root,
  Selector,
};

export type { OpuSearchProps };
